
    import './styles.scoped.css';
    export default {
  "selectable-item": "awsui_selectable-item_15o6u_2fwtd_5",
  "pad-bottom": "awsui_pad-bottom_15o6u_2fwtd_25",
  "has-background": "awsui_has-background_15o6u_2fwtd_34",
  "highlighted": "awsui_highlighted_15o6u_2fwtd_37",
  "selected": "awsui_selected_15o6u_2fwtd_37",
  "next-item-selected": "awsui_next-item-selected_15o6u_2fwtd_56",
  "is-keyboard": "awsui_is-keyboard_15o6u_2fwtd_64",
  "parent": "awsui_parent_15o6u_2fwtd_67",
  "child": "awsui_child_15o6u_2fwtd_73",
  "disabled": "awsui_disabled_15o6u_2fwtd_79",
  "virtual": "awsui_virtual_15o6u_2fwtd_85",
  "measure-strut": "awsui_measure-strut_15o6u_2fwtd_96",
  "measure-strut-first": "awsui_measure-strut-first_15o6u_2fwtd_105"
};
  